<template>
  <div class="question-name display-flex-center justify-content-center position-rel">
      <div v-if="!isHideNextPrevCat" class="question-name__prev__lesson cursor-pointer position-rel only-pc" @click="directToCat('prev')"><i class="icon-first-page primary-color font-size-20 cursor-pointer"></i></div>
      <div class="question-name__prev cursor-pointer position-rel" @click="directQuestion(activeSlider-1)" slot="button-prev"><i class="icon-prev primary-color font-size-20 cursor-pointer"></i></div>
      <swiper ref="swiper_question" id="swiper_question" class="swiper" :options="optionSlider">
        <swiperSlide v-for="(item, index) of dataSource" :key="index">
          <a
            :class="{
              'active' : activeSlider === index,
              'curr': item.current || (index === parseInt($route.query.cauhoi) - 1 && !isDontShowResult) || (item.isWorked && !item.isNoAnswer), 
              'success': item.type && item.type !== typeDownAnswer && !isDontShowResult && ((item.answerStatus !== null && item.answerStatus === 'success') || (item.statusWorked && !item.workedFail) || (item.isWorked && item.isTrue)), 
              'error': item.type && item.type !== typeDownAnswer && !isDontShowResult && !item.isNoAnswer && ((item.answerStatus !== null && item.answerStatus === 'error') || (item.statusWorked && item.workedFail === 'error') || (item.isWorked && !item.isTrue)) 
            }" 
            @click="directQuestion(index + 1)"
          >
              {{ item.name }}
            </a>
        </swiperSlide>
      </swiper>
      <div class="question-name__next cursor-pointer position-rel" @click="directQuestion(activeSlider+1)" slot="button-next"><i class="icon-next primary-color font-size-20 cursor-pointer"></i></div>
      <div
        v-if="!isHideNextPrevCat"
        class="question-name__next__lesson cursor-pointer position-rel only-pc"
        @click="directToCat('next')"
      >
        <i class="icon-last-page primary-color font-size-20 cursor-pointer"></i>
      </div>
  </div>
</template>

<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  import { mapActions } from 'vuex'
  import { TYPE_DOWN_ANSWER } from '@/modules/question/preview-question/_store/constants'


  export default {
    name: 'SliderNameQuestion',
    props: {
      dataSource: Array,
      isHideNextPrevCat: Boolean,
      isDontShowResult: Boolean,
      scrollOffset: Number
    },
    components: {
      swiper, 
      swiperSlide,
    },
    data () {
      return {
        activeSlider: 0,
        nameRouter: this.$route.name,
        isShowMore: false,
        mountedSetIndex: true, // for set item current load page
        optionSlider: {
          slidesPerView: 8,
          spaceBetween: 10,
          slidesPerGroup: 3,
          loop: false,
          loopFillGroupWithBlank: true,
          breakpoints: { 
            1199: {slidesPerView: 6, slidesPerGroup: 3},
            991: {slidesPerView: 6, slidesPerGroup: 2},
            767: {slidesPerView: 3, slidesPerGroup: 2},
            575: {slidesPerView: 2, slidesPerGroup: 1}
          },
          navigation: {
            nextEl: `.question-name__next`,
            prevEl: `.question-name__prev`
          }
        },
        typeDownAnswer: TYPE_DOWN_ANSWER
      }
    },
    computed: {
      swiper () {
        return this.$refs.swiper_question.swiper
      },
      screenWidth () {
        return window.innerWidth
      },
    },
    mounted () {
      this.setActiveItem()
    },
    methods: {
      ...mapActions('common', ['setLoading', 'actionCheckInfoExcercise', 'setToggleModalActivePage', 'acSetDataBookActiveWant', 'acToggleModalActiveBook', 'acToggleModaShowHelp', 'actionCheckRouterHelp', 'actionGetVideoHelp', 'acToggleModaShowError', 'actionSetBookIndexId','actionSetBookIdForError', 'setActionCheckQuestion', 'actionSetPageNoBook', 'actionCheckExcercise', 'actionCheckInfoExcercise', 'actionCheckPage']),

      // handleShowMoreQuestion () {
      //   // console.log('show more quếtion');
      //   this.isShowMore = !this.isShowMore
      // },

      setActiveItem () {
        const questionIndex = parseInt(this.$route.query.cauhoi) - 1
        questionIndex > 8 && this.swiper.slideTo(questionIndex, 1000, false)
        this.activeSlider = parseInt(this.$route.query.cauhoi);
      },

      directQuestion (position) {
        
        if(position>this.dataSource.length){
          return
        }
        if(position<1){
          return
        }
        let queryParams = this.$route.query
        this.handleNextPrevSlide(position)
        this.activeSlider = position;
        queryParams.cauhoi != position && this.$router.replace({ query: {...queryParams, cauhoi: position} })
      },

      handleNextPrevSlide (position) {
        if (this.screenWidth < 768) {
          return
        }
        const spaceAction = 2
        const slidePerGroup = this.screenWidth > 991 ? 3 : 2
        let slidesPerView = 8
        
        if (this.screenWidth > 991 && this.screenWidth < 1200) {
          slidesPerView = 6
        } else if (this.screenWidth > 767 && this.screenWidth < 992) {
          slidesPerView = 4
        }
        const belowLimit = slidePerGroup*(this.swiper.snapIndex + 1)
        const aboveLimit = (belowLimit - spaceAction) + slidesPerView
        if (position < belowLimit) {
          this.swiper.slidePrev(1000)
        } else if (position >= (aboveLimit -spaceAction)) {
          this.swiper.slideNext(1000)
        }
      },

      directToCat (type = 'next') {
        this.actionCheckInfoExcercise(Math.random())
        let result = type === 'next' ? 'handleNextCat' : 'handlePrevCat'
        this.$emit(result, true)
      }
    }
  }
</script>

<style lang="scss" scoped>
.all-question{
  position: absolute;
  transition: bottom 0.3s ease-out, opacity 0.1s ease;
  // transition: 1s;
  width: auto;
  // height: 200px;
  bottom: 0;
  opacity: 0;
  z-index: -1;
    //   left: 50%;
    // transform: translate(-50%, -200%);
  left: 18%;
  background: #f3f6fb;
  border: 1px solid #d2d2d2;
  border-radius: 8px 8px 0 0;
  // border-top-left-radius: 8px;
  // border-top-right-radius: 8px;

  &.show-more{
    transition: bottom 0.2s ease-out, opacity 0.6s ease;
    opacity: 1;
    bottom: 50px;
    z-index: 2;
    // transform: translate3d(0px, -135px, 0px);
    // display: block;
  }
  // &.hide-more{
  //   // transition: bottom 0.3s;
  //   // bottom: 0;
  //   // transform: translate3d(0px, 200px, 0px);
  //   // display: none;
  //   opacity: 0;
  // }

  @media screen and (max-width: 768px){
    width: 100%;
    left: 6%;
  }
  @media screen and (max-width: 575px){
    width: 450px;
    left: 0%;
  }
  @media screen and (max-width: 425px){
    width: 350px;
  }
  @media screen and (max-width: 375px){
    width: 315px;
  }
  @media screen and (max-width: 320px){
    width: 260px;
    bottom: -68px;
  }
  .form-qes{
    width: 10%;
    text-align: center;
    // min-width: auto !important;
    @media screen and (max-width: 575px){
      width: auto;
    }
    @media screen and (max-width: 375px){
      // width: au%;
    }
  }
  .qes-mini{
  }
  a{
    padding: 4px 10px;
    line-height: 2;
    position: relative;
    color: #40505E;
    font-family: 'sandisplaypro-semi', 'sans-serif';
    margin: 0 2px;
    &::after{
      content: "";
      height: 2.5px;
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
      border-radius: 3px 3px 0 0;
    }
  }
  // a.error{
  //   &::after{
  //     background: #F46055;
  //   }
  // }
  // a.success{
  //   &::after{
  //     background: #38c172;
  //   }
  // }
  // a.curr{
  //   &::after{
  //     background: #0f3dba;
  //   }
  // }
}
#swiper_question {
  max-width: 640px;
  margin: 0;

  @media screen and ( min-width: 992px ) and ( max-width: 1199px ) {
    max-width: 480px;
  }
  @media screen and ( max-width: 575px ) {
    max-width: 160px;
  }
}
.question-name {
  >* {
    padding: 0 6px;
    
  }

  .swiper-slide, .form-qes {
    min-width: 70px;
    text-align: center;
    
    a {
      padding: 0 6px;
      @extend .position-rel;
      @extend .display-block;
      @extend .primary-color-txt;
      @extend .font-sanpro-semibold;
      line-height: 2;
      cursor: pointer;

      &:after {
        content: "";
        @extend .bg-transparent;
        height: 2.5px;
        @extend .full-width;
        position: absolute;
        bottom: 0;
        left: 0;
        border-radius: 3px 3px 0 0;
      }

      &.curr {
        &:after {
          @extend .primary-bg-color;
        }
      }

      &.success {
        &:after {
          @extend .secondary-bg-color;
        }
      }

      &.error {
        &:after {
          @extend .four-bg-color;
        }
      }
    }

    @media screen and ( max-width: 575px ) {
      // max-width: 50px;
      // min-width: 30px;
      padding-left: 0;
    }
  }
}
 @media screen and ( max-width: 991px ) {
     .book-viewer__footer {
        .question-name__prev,.question-name__next {
           display: none;
        }
      .swiper-container {
        max-width: 100% !important;
        width: 100% !important;
        .swiper-slide {
        width: 40px !important;
        min-width: 40px !important;
        border-radius: 50%;
        background-color: $color_bg_gray_light;
        a {
          color: $secondary_text_color;
          border-radius: 50%;
          background: #E1EFFF;
          &.active {
            //  color: $primary_color !important;
            //  background: $btn_hover_color;
          }
          &.curr {
            color: $primary_color;
          }

          &.success {
            color: $secondary-color;
          }

          &.error {
            color: $four-color;
          }
        }
        a::after {
          display: none
        }  
      }
      }
    }
}

@media screen and (max-width: 320px){
  .exercise-detail__action{
    width: 100px;
  }
}
</style>